import PersonalOfferPreviewHeader from './PersonalOfferPreviewHeader'

export default PersonalOfferPreviewHeader
export { PersonalOfferPreviewHeader }
